import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ea59dece"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "text-2xl font-semibold text-gray-900 hidden md:block py-2 pt-4" }, "\n    Processed Work\n  ", -1));
const _hoisted_2 = { class: "flex flex-col font-light py-2 items-left" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = { class: "mr-2" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "startDate",
    class: "text-sm font-medium text-gray-700"
}, "Start Date:", -1));
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "mr-2" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "endDate",
    class: "text-sm font-medium text-gray-700"
}, "End Date:", -1));
const _hoisted_9 = ["value"];
const _hoisted_10 = ["disabled"];
const _hoisted_11 = { class: "table-border-padding" };
const _hoisted_12 = { class: "border rounded-lg pt-2 min-w-[900px]" };
const _hoisted_13 = { class: "min-w-full text-center text-sm" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", { class: "divide-gray-200" }, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "border-b py-2 font-normal text-sm w-10"
        }),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "5",
            class: "border-b py-2 font-normal text-sm text-left"
        }, "\n                Employee Email\n              "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                Offers\n              "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                Amends\n              "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            colspan: "6",
            class: "border-b py-2 font-normal text-sm"
        }, "\n                Leavers\n              ")
    ])
], -1));
const _hoisted_15 = { class: "divide-y border-b divide-gray-200" };
const _hoisted_16 = {
    key: 0,
    class: "flex justify-center"
};
const _hoisted_17 = {
    key: 1,
    class: "flex justify-center"
};
const _hoisted_18 = {
    colspan: "5",
    class: "font-light text-left"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { colspan: "6" };
const _hoisted_21 = { colspan: "6" };
const _hoisted_22 = { colspan: "6" };
const _hoisted_23 = {
    key: 0,
    class: "process-row"
};
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "font-medium"
}, "Breakdown by SLA:", -1));
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50 border-b font-bold" }, "\n                  1\n                ", -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50 border-b font-bold" }, "\n                  2\n                ", -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50 border-b font-bold" }, "\n                  3\n                ", -1));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50 border-b font-bold" }, "\n                  4\n                ", -1));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50 border-b font-bold" }, "\n                  5+\n                ", -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "w-px" }, null, -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50 border-b font-bold" }, "\n                  1\n                ", -1));
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50 border-b font-bold" }, "\n                  2\n                ", -1));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50 border-b font-bold" }, "\n                  3\n                ", -1));
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50 border-b font-bold" }, "\n                  4\n                ", -1));
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50 border-b font-bold" }, "\n                  5+\n                ", -1));
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "w-px" }, null, -1));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50 border-b font-bold" }, "\n                  1\n                ", -1));
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50 border-b font-bold" }, "\n                  2\n                ", -1));
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50 border-b font-bold" }, "\n                  3\n                ", -1));
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50 border-b font-bold" }, "\n                  4\n                ", -1));
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50 border-b font-bold" }, "\n                  5+\n                ", -1));
const _hoisted_42 = {
    key: 1,
    class: ""
};
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "font-medium"
}, null, -1));
const _hoisted_44 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_45 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_46 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_47 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_48 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "w-px" }, null, -1));
const _hoisted_50 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_51 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_52 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_53 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_54 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", { class: "w-px" }, null, -1));
const _hoisted_56 = { class: "whitespace-nowrap px-3 py-2 bg-green-100 bg-opacity-50" };
const _hoisted_57 = { class: "whitespace-nowrap px-3 py-2 bg-lime-100 bg-opacity-50" };
const _hoisted_58 = { class: "whitespace-nowrap px-3 py-2 bg-yellow-100 bg-opacity-50" };
const _hoisted_59 = { class: "whitespace-nowrap px-3 py-2 bg-orange-100 bg-opacity-50" };
const _hoisted_60 = { class: "whitespace-nowrap px-2 py-2 bg-red-100 bg-opacity-50" };
const _hoisted_61 = {
    key: 2,
    class: "border-b details"
};
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "font-medium"
}, null, -1));
const _hoisted_63 = {
    colspan: "6",
    class: "whitespace-normal p-1 text-left text-xs"
};
const _hoisted_64 = {
    colspan: "6",
    class: "whitespace-normal p-1 text-left text-xs"
};
const _hoisted_65 = {
    colspan: "6",
    class: "whitespace-normal p-1 text-left text-xs"
};
const _hoisted_66 = { class: "divide-y divide-gray-200" };
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", null, null, -1));
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "5",
    class: "font-normal text-left"
}, [
    /*#__PURE__*/ _createElementVNode("a", { href: "#" }, "Totals")
], -1));
const _hoisted_69 = { colspan: "6" };
const _hoisted_70 = { colspan: "6" };
const _hoisted_71 = { colspan: "6" };
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/vue/solid';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProcessedWork',
    props: {
        formData: {},
        overall: {},
        users: {}
    },
    emits: ["update:formData", "searchProcessed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const model = ref(props.formData);
        const rowDetail = ref([]);
        const showWorkDetail = (id) => {
            /*
              checks rowDetail for user id, if present it's removed, else id pushed into rowDetail
              used to expand the 'processed work' table row for more detail
            */
            const index = rowDetail.value.indexOf(id);
            if (index > -1) {
                rowDetail.value.splice(index, 1);
            }
            else {
                rowDetail.value.push(id);
            }
        };
        const handleInput = (event) => {
            const target = event.target;
            const { name, value } = target;
            model.value[name] = value;
            emit('update:formData', {
                formName: 'processedWork',
                formData: model.value,
            });
        };
        const sum = (data = []) => {
            return (data?.reduce((accumulator, currentValue) => {
                return accumulator + currentValue;
            }, 0) ?? 0);
        };
        const searchProcessed = () => {
            emit('searchProcessed');
        };
        const slaPercent = (a = []) => {
            const array = [...a];
            const newArray = [0, array[0] + array[1], ...array.splice(2)];
            const sla = newArray.indexOf(Math.max(...newArray));
            const percent = sla > 0 ? Math.round((newArray[sla] / sum(newArray)) * 100) : 0;
            const response = {
                sla: `${sla} ${sla > 1 ? 'days' : 'day'}`,
                percent,
            };
            return response;
        };
        const slaText = (user, type, text) => {
            const slaData = slaPercent(user[type]);
            return slaData?.percent > 0
                ? `${slaData?.percent}% of ${text} completed within ${slaData?.sla}`
                : '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _createTextVNode(),
                _createElementVNode("section", null, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, [
                                _hoisted_5,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "startDate",
                                    value: _ctx.formData?.startDate,
                                    type: "date",
                                    min: "0",
                                    name: "startDate",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onInput: handleInput
                                }, null, 40, _hoisted_6)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: "endDate",
                                    value: _ctx.formData?.endDate,
                                    type: "date",
                                    min: "0",
                                    name: "endDate",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                    onInput: handleInput
                                }, null, 40, _hoisted_9)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                class: "inline-flex items-center align-bottom rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400 h-9 mt-7",
                                disabled: !_ctx.formData?.startDate || !_ctx.formData?.endDate,
                                onClick: searchProcessed
                            }, "\n          Search\n        ", 8, _hoisted_10)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("table", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.users), (user, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            _createElementVNode("tr", _hoisted_15, [
                                                (rowDetail.value.includes(user))
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                                        _createElementVNode("button", null, [
                                                            _createVNode(_unref(ChevronDownIcon), {
                                                                class: "h-5 w-5 mr-2",
                                                                onClick: ($event) => (showWorkDetail(user))
                                                            }, null, 8, ["onClick"])
                                                        ])
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                        _createElementVNode("button", null, [
                                                            _createVNode(_unref(ChevronRightIcon), {
                                                                class: "h-5 w-5 mr-2",
                                                                onClick: ($event) => (showWorkDetail(user))
                                                            }, null, 8, ["onClick"])
                                                        ])
                                                    ])),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_18, [
                                                    _createElementVNode("p", {
                                                        class: "cursor-pointer",
                                                        onClick: ($event) => (showWorkDetail(user))
                                                    }, _toDisplayString(user), 9, _hoisted_19)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_20, _toDisplayString(sum(_ctx.users[user].OFFER)), 1),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_21, _toDisplayString(sum(_ctx.users[user].AMEND)), 1),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_22, _toDisplayString(sum(_ctx.users[user].LEAVER)), 1)
                                            ]),
                                            _createTextVNode(),
                                            (rowDetail.value.includes(user))
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                                    _hoisted_24,
                                                    _createTextVNode(),
                                                    _hoisted_25,
                                                    _createTextVNode(),
                                                    _hoisted_26,
                                                    _createTextVNode(),
                                                    _hoisted_27,
                                                    _createTextVNode(),
                                                    _hoisted_28,
                                                    _createTextVNode(),
                                                    _hoisted_29,
                                                    _createTextVNode(),
                                                    _hoisted_30,
                                                    _createTextVNode(),
                                                    _hoisted_31,
                                                    _createTextVNode(),
                                                    _hoisted_32,
                                                    _createTextVNode(),
                                                    _hoisted_33,
                                                    _createTextVNode(),
                                                    _hoisted_34,
                                                    _createTextVNode(),
                                                    _hoisted_35,
                                                    _createTextVNode(),
                                                    _hoisted_36,
                                                    _createTextVNode(),
                                                    _hoisted_37,
                                                    _createTextVNode(),
                                                    _hoisted_38,
                                                    _createTextVNode(),
                                                    _hoisted_39,
                                                    _createTextVNode(),
                                                    _hoisted_40,
                                                    _createTextVNode(),
                                                    _hoisted_41
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(),
                                            (rowDetail.value.includes(user))
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                                    _hoisted_43,
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.users[user].OFFER[0] + _ctx.users[user].OFFER[1]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.users[user].OFFER[2]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.users[user].OFFER[3]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.users[user].OFFER[4]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.users[user].OFFER[5]), 1),
                                                    _createTextVNode(),
                                                    _hoisted_49,
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.users[user].AMEND[0] + _ctx.users[user].AMEND[1]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.users[user].AMEND[2]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.users[user].AMEND[3]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.users[user].AMEND[4]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.users[user].AMEND[5]), 1),
                                                    _createTextVNode(),
                                                    _hoisted_55,
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.users[user].LEAVER[0] + _ctx.users[user].LEAVER[1]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.users[user].LEAVER[2]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.users[user].LEAVER[3]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.users[user].LEAVER[4]), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.users[user].LEAVER[5]), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(),
                                            (rowDetail.value.includes(user))
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [
                                                    _hoisted_62,
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_63, _toDisplayString(slaText(_ctx.users[user], "OFFER", "Offers")), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_64, _toDisplayString(slaText(_ctx.users[user], "AMEND", "Amends")), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_65, _toDisplayString(slaText(_ctx.users[user], "LEAVER", "Leavers")), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 64));
                                    }), 128)),
                                    _createTextVNode(),
                                    _createElementVNode("tr", _hoisted_66, [
                                        _hoisted_67,
                                        _createTextVNode(),
                                        _hoisted_68,
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_69, _toDisplayString(sum(_ctx.overall?.OFFER)), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_70, _toDisplayString(sum(_ctx.overall?.AMEND)), 1),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_71, _toDisplayString(sum(_ctx.overall?.LEAVER)), 1)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
